import { useEffect, useState, useCallback } from 'react';
import LoadMoreButton from './components/LoadMoreButton';

const PLATFORMS = ['', 'tiktok', 'youtube', 'instagram'];

export default function AdminScrapLog() {
  const today = new Date().toISOString().slice(0, 10);
  const [date, setDate] = useState(today);
  const [platform, setPlatform] = useState('');
  const [items, setItems] = useState([]);
  const [cursor, setCursor] = useState(null);
  const [hasMore, setHasMore] = useState(false);

  const load = useCallback(async (reset = false) => {
    const params = new URLSearchParams();
    if (date) params.set('date', date);
    if (platform) params.set('platform', platform);
    if (!reset && cursor) params.set('cursor', String(cursor));
    params.set('limit', '50');
    const res = await fetch('/api/admin/scrap/log?' + params.toString(), { credentials: 'include' });
    if (!res.ok) return;
    const data = await res.json();
    setItems(prev => reset ? data.data : [...prev, ...data.data]);
    setCursor(data.next_cursor);
    setHasMore(!!data.next_cursor);
  }, [date, platform, cursor]);

  useEffect(() => {
    setCursor(null);
    load(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date, platform]);

  const levelColor = (lv) => lv === 'error' ? '#ef4444' : '#f59e0b';

  return (
    <div style={{ background: '#fff', borderRadius: 8, padding: 16, boxShadow: '0 1px 6px rgba(0,0,0,0.06)' }}>
      <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
        <input type="date" value={date} max={today} onChange={e => setDate(e.target.value)}
          style={{ padding: '6px 10px', border: '1px solid #ddd', borderRadius: 6, fontSize: 14 }} />
        <select value={platform} onChange={e => setPlatform(e.target.value)}
          style={{ padding: '6px 10px', border: '1px solid #ddd', borderRadius: 6, fontSize: 14 }}>
          {PLATFORMS.map(p => <option key={p} value={p}>{p || '(모든 플랫폼)'}</option>)}
        </select>
      </div>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
        <thead>
          <tr style={{ textAlign: 'left', color: '#666', borderBottom: '1px solid #eee' }}>
            <th style={{ padding: 6 }}>시각</th>
            <th style={{ padding: 6 }}>platform</th>
            <th style={{ padding: 6 }}>country</th>
            <th style={{ padding: 6 }}>cate / sub</th>
            <th style={{ padding: 6 }}>stage</th>
            <th style={{ padding: 6 }}>level</th>
            <th style={{ padding: 6 }}>reason</th>
            <th style={{ padding: 6 }}>message</th>
          </tr>
        </thead>
        <tbody>
          {items.map(r => (
            <tr key={r.id} style={{ borderBottom: '1px solid #f3f3f3' }}>
              <td style={{ padding: 6, whiteSpace: 'nowrap' }}>{new Date(r.created).toLocaleString()}</td>
              <td style={{ padding: 6 }}>{r.platform}</td>
              <td style={{ padding: 6 }}>{r.country || '-'}</td>
              <td style={{ padding: 6 }}>{r.cate || '-'}{r.sub_cate ? ` / ${r.sub_cate}` : ''}</td>
              <td style={{ padding: 6 }}>{r.stage}</td>
              <td style={{ padding: 6, color: levelColor(r.level), fontWeight: 600 }}>{r.level}</td>
              <td style={{ padding: 6 }}>{r.reason}</td>
              <td style={{ padding: 6, color: '#888' }}>{r.message || '-'}</td>
            </tr>
          ))}
          {items.length === 0 && (
            <tr><td colSpan={8} style={{ padding: 16, textAlign: 'center', color: '#aaa' }}>로그 없음</td></tr>
          )}
        </tbody>
      </table>
      <LoadMoreButton hasMore={hasMore} onClick={() => load(false)} />
    </div>
  );
}
